import { render, staticRenderFns } from "./workingFeel.vue?vue&type=template&id=4072d909&scoped=true"
import script from "./workingFeel.vue?vue&type=script&lang=js"
export * from "./workingFeel.vue?vue&type=script&lang=js"
import style0 from "./workingFeel.vue?vue&type=style&index=0&id=4072d909&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072d909",
  null
  
)

export default component.exports